import { Action, createReducer, on } from '@ngrx/store';
import * as actions from '../actions';
import { ISetupStatusResponse } from '../../features/todos/models/setup-status.model';
import { ITaxNumberSaveResponse } from '../models/tax-numbers.model';

export const saveTaxNumberFeatureKey = 'saveTaxNumber';

export interface SaveTaxNumberState {
  saveTaxNumberResponse: ITaxNumberSaveResponse | null;
}

export const initialState: SaveTaxNumberState = {
  saveTaxNumberResponse: null
};

export const reducer = createReducer(
  initialState,
  on(actions.saveTaxNumberSuccess, (state, action) => ({
    ...state,
    saveTaxNumberResponse: action.response
  }))
);

export const getSaveTaxNumberResponse = (state: SaveTaxNumberState) => state.saveTaxNumberResponse;
